import { http, type Page } from '@shared/api';
import type { ChangeOrderStatusRequest, OrderListQuery, OrderView } from '../model/types';

function buildParams(query: OrderListQuery): URLSearchParams {
  const p = new URLSearchParams();
  if (query.status?.length) p.set('status', query.status.join(','));
  p.set('page', String(query.page ?? 0));
  p.set('size', String(query.size ?? 20));
  return p;
}

export const orderApi = {
  list: (query: OrderListQuery) =>
    http.get('orders', { searchParams: buildParams(query) }).json<Page<OrderView>>(),

  get: (id: string) => http.get(`orders/${id}`).json<OrderView>(),

  changeStatus: (id: string, body: ChangeOrderStatusRequest) =>
    http.patch(`orders/${id}/status`, { json: body }).json<OrderView>(),

  attachDocument: (id: string, mediaId: string) =>
    http.post(`orders/${id}/documents`, { json: { mediaId } }).json<OrderView>(),

  detachDocument: (id: string, mediaId: string) =>
    http.delete(`orders/${id}/documents/${mediaId}`).json<OrderView>(),
};
